import { CloudUpload } from 'lucide-react';

import { FIELD_OPTIONAL_TEXT } from '#/utils/constants';

function CustomInput({
  label,
  type = 'text',
  className = '',
  onChange,
  placeholder,
  isError,
  errorMessage,
  isRequired = true,
  ...props
}) {
  const isFileType = type === 'file';
  const optionalText = !isRequired ? ` ${FIELD_OPTIONAL_TEXT}` : '';

  return (
    <div className="custom-input">
      {label && <label>{label}</label>}
      <div className={isFileType ? 'file-input' : ''}>
        <input
          type={type}
          onChange={onChange}
          placeholder={`${placeholder} ${optionalText}`}
          className={`form-control ${className} ${isError ? 'error-input' : ''}`}
          {...props}
        />
        {isFileType && (
          <div className="file-input-text">
            <CloudUpload />
            <span>
              {placeholder} {optionalText}
            </span>
          </div>
        )}
      </div>
      {isError && errorMessage && <p>{errorMessage}</p>}
    </div>
  );
}

export default CustomInput;
